import { FunctionComponent, useCallback, useState } from 'react'
import { MdCheck, MdPlayArrow } from 'react-icons/md'

import Button from 'shared/components/Button'
import Modal from 'shared/components/Modal'
import { validateTypeFile } from 'shared/utils/validates'

import { steps } from '../../'
import iconPhone from 'shared/assets/icons/icon-telefone.png'
import cnh from 'shared/assets/images/cnh.jpeg'
import rg from 'shared/assets/images/rg.png'
import InputFile from 'shared/components/InputFile'
import Page from 'shared/components/Page'
import { colors } from 'shared/styles/colors'
import { IPhotoProps } from './PhotoComponent.types'
import {
  Container,
  Cnh,
  ContainerCenter,
  ContainerDoc,
  ContainerInput,
  ContainerModal,
  ContainerPhoto,
  Description,
  Rg,
  StyledButton,
  Title,
} from './styles'

const Photo: FunctionComponent<IPhotoProps> = ({ setSelectedStep }) => {
  const [photoOk, setPhotoOk] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpPhotoBase64')) {
      return true
    }

    return false
  })
  const [file, setFile] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpPhotoName')) {
      return localStorage.getItem('@TMov:SignUpPhotoName')
    }

    return ''
  })
  const [openModal, setOpenModal] = useState(true)
  const [isWrongExtension, setIsWrongExtension] = useState(false)

  const handleSelectFile = useCallback((base64: string, fileName: string) => {
    setFile(fileName)
    if (validateTypeFile(fileName)) {
      setIsWrongExtension(false)
      localStorage.setItem('@TMov:SignUpPhotoBase64', base64)
      localStorage.setItem('@TMov:SignUpPhotoName', fileName)
      setPhotoOk(true)
    } else {
      setIsWrongExtension(true)
      setPhotoOk(false)
    }
  }, [])

  return (
    <>
      <Modal
        size={'large'}
        showCloseButton={true}
        openModal={openModal}
        onCloseModal={() => {
          setOpenModal(false)
        }}
      >
        <ContainerModal>
          <Title>Atenção!</Title>

          <Description>
            Seu documento precisa estar aberto para validarmos frente e verso,
            como no exemplo a seguir:
          </Description>

          <ContainerDoc>
            <ContainerPhoto>
              <Rg src={rg} />
              <Title>RG</Title>
            </ContainerPhoto>
            <ContainerPhoto>
              <Cnh src={cnh} />
              <Title>CNH</Title>
            </ContainerPhoto>
          </ContainerDoc>

          <Button
            color={colors.orange}
            onClick={() => {
              setOpenModal(false)
            }}
          >
            <MdCheck /> Ok
          </Button>
        </ContainerModal>
      </Modal>
      <Page
        icon={iconPhone}
        title="Boa!<br />Estamos quase lá, agora precisamos de uma imagem do seu RG ou CNH (frente e verso):"
        goBackTo={() => {
          setSelectedStep(steps.Cnpj)
        }}
      >
        <Container>
          <ContainerInput>
            <InputFile
              id="photo-singup"
              onSelectFile={handleSelectFile}
              file={file}
              isWrongExtension={isWrongExtension}
            />
          </ContainerInput>
          <ContainerCenter>
            <StyledButton
              color={photoOk ? colors.green : colors.grayLight}
              disabled={!photoOk}
              onClick={() => {
                setSelectedStep(steps.CepAddress)
              }}
            >
              <MdPlayArrow /> Próximo
            </StyledButton>
          </ContainerCenter>
        </Container>
      </Page>
    </>
  )
}

export default Photo
